export enum Alerts {
    OverDueDocuments = "Documentation Overdue",
    MissedVisits = "Missed Visits",
    MissedMDSignatures = "Missed MD Signatures",
    MissedTimeSheets = "Missing Time Sheets",
    TherapyScreenOrReferral = "Therapy Screen/Referral",
    NoTherapyThreeDays = "No Tx for 3 Days",
    Discrepancies = "Discrepancies"
}

export enum DashboardTaskAlertTypes {
    OverDueDocuments = 1,
    MissedVisits = 2,
    MissedMDSignatures = 3,
    MissingTimeSheets = 4,
    TherapyScreenOrReferral= 5,
    NoTherapyThreeDays = 6,
    Discrepancies = 7
};

export const DisplayToAlertTypeMap: Record<Alerts, DashboardTaskAlertTypes> = {
    [Alerts.OverDueDocuments]: DashboardTaskAlertTypes.OverDueDocuments,
    [Alerts.MissedVisits]: DashboardTaskAlertTypes.MissedVisits,
    [Alerts.MissedMDSignatures]: DashboardTaskAlertTypes.MissedMDSignatures,
    [Alerts.MissedTimeSheets]: DashboardTaskAlertTypes.MissingTimeSheets,
    [Alerts.TherapyScreenOrReferral]: DashboardTaskAlertTypes.TherapyScreenOrReferral,
    [Alerts.NoTherapyThreeDays]: DashboardTaskAlertTypes.NoTherapyThreeDays,
    [Alerts.Discrepancies]: DashboardTaskAlertTypes.Discrepancies
}

export const AlertTypeToDisplayMap: Record<DashboardTaskAlertTypes, Alerts> = {
    [DashboardTaskAlertTypes.OverDueDocuments]: Alerts.OverDueDocuments,
    [DashboardTaskAlertTypes.MissedVisits]: Alerts.MissedVisits,
    [DashboardTaskAlertTypes.MissedMDSignatures]: Alerts.MissedMDSignatures,
    [DashboardTaskAlertTypes.MissingTimeSheets]: Alerts.MissedTimeSheets,
    [DashboardTaskAlertTypes.TherapyScreenOrReferral]: Alerts.TherapyScreenOrReferral,
    [DashboardTaskAlertTypes.NoTherapyThreeDays]: Alerts.NoTherapyThreeDays,
    [DashboardTaskAlertTypes.Discrepancies]: Alerts.Discrepancies
};

export function getAlertType(display: Alerts): DashboardTaskAlertTypes {
    return DisplayToAlertTypeMap[display];
}

export function getAlertDisplay(alertType: DashboardTaskAlertTypes): Alerts {
    return AlertTypeToDisplayMap[alertType];
}

export enum FilterDateRange{
    LastDay = "Last Day",
    LastThreeDays = "Last 3 Days",
    LastWeek = "Last 1 Week",
    LastFourteenDays = "Last 14 Days",
    LastMonth = "Last Month"
  }

 export enum AlertDetailsEnum {
    Patient = 1,
    Therapist = 2,
    DocumentType = 3,
    Discipline = 4,
    Date = 5,
    AgendaTime = 6,
    AgendaMode = 7
}

export enum AlertFiltersEnum {
    Discipline = 1,
    Patient = 2,
    Therapist = 3,
    Physician = 4,
}